export default __webpack_public_path__ + "static/media/roadhog-hook.158ac2dd.mp3";